module.exports = __webpack_public_path__ + "static/media/Slider.c6361ffc.mov";